import React from 'react';
import App from './App';

function AppContainer(props) {
  return <App {...props} />;
}

export default AppContainer;
